/**!
 * Created by Leonardo Cheslacki on 14/03/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

module.exports.scene = {
    layerActions: {
        /**
         * Init in Actions.
         * StageClass.main.scene.layerActions.frame01Index(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Index: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageMain({current_name: current_name}).initIndex);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Menu(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Menu: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initMenu);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Cover(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Portal: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initPortal);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Cover(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Cover: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initCover);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Record(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Record: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initRecord);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Paginate(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Paginate: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initPaginate);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Gallery(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Gallery: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initGallery);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Implantation(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Implantation: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initImplantation);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01ImplantationPaginate(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01ImplantationPaginate: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initImplantationPaginate);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01PlantPaginate(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01PlantPaginate: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initPlantPaginate);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01LocalizationPaginate(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01LocalizationPaginate: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initLocalizationPaginate);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01LocalizationDynamic(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01LocalizationDynamic: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initLocalizationDynamic);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01ProjectPaginate(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01ProjectPaginate: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initProjectPaginate);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Rational(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Rational: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initRationalPaginate);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Institutional(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Institutional: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initInstitutionalPaginate);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01View(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01View: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initView);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Orientation(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Orientation: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initOrientation);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01OrientationPaginate(this, 'current_name', 'current_page');
         * @param _this
         * @param current_name
         * @param current_page
         */
        frame01OrientationPaginate: (_this, current_name, current_page) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {
                AllTap.$pageCurrent({current_name: current_name}).initOrientationPaginate(current_page);
            });
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Zoom(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Zoom: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initZoom);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01ZoomPaginate(this, 'current_name', 'current_page');
         * @param _this
         * @param current_name
         * @param current_page
         */
        frame01ZoomPaginate: (_this, current_name, current_page) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this, [`_this_${current_page}`]: _this}, () => {
                AllTap.$pageCurrent({current_name: current_name}).initZoomPaginate(current_page);
            });
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Slider(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Slider: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initSlider);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Scroll(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Scroll: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initScroll);
        },

        /**
         * Init in Actions.
         * StageClass.main.scene.layerActions.frame01Quiz(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Quiz: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initQuiz);
        },

        /**
         * Init in Actions.
         * StageClass.main.scene.layerActions.frame01Memory(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Memory: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initMemory);
        },

        /**
         * Init in Actions.
         * StageClass.main.scene.layerActions.frame01Marquee(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Marquee: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initMarquee);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01360(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01360: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).init360);
        },

        /**
         * Init in Actions.
         * StageClass.main.scene.layerActions.frame01Video(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Video: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initVideo);
        },

        /**
         * Init in Actions.
         * StageClass.main.scene.layerActions.frame01Tour(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Tour: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initTour);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01ImplantationAndOrientation(this, 'current_name', 'current_page');
         * @param _this
         * @param current_name
         * @param current_page
         */
        frame01ImplantationAndOrientation: (_this, current_name, current_page) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {
                AllTap.$pageCurrent({current_name: current_name}).initImplantationAndOrientation(current_page);
            });
        },

        /**
         * Init in Actions.
         * StageClass.main.scene.layerActions.frame01External(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01External: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initExternal);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Slide(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Slide: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initSlide);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Project(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Project: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initProject);
        },

        /**
         * Init in Actions.
         * window.StageClass;
         * StageClass.main.scene.layerActions.frame01Sector(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Sector: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, AllTap.$pageCurrent({current_name: current_name}).initSector);
        },

        /**
         * Init in Actions effects.
         * window.StageClass;
         * StageClass.main.scene.layerActions.effectStart('current_name');
         * @param current_name
         */
        effectStart: (current_name) => {
            AllTap.$supportEffect({current_name: current_name}).initStart();
        },

        /**
         * Init in Actions effects.
         * window.StageClass;
         * StageClass.main.scene.layerActions.effectComplete('current_name');
         * @param current_name
         */
        effectComplete: (current_name) => {
            AllTap.$supportEffect({current_name: current_name}).initComplete();
        },

        /**
         * Init in Actions effects.
         * window.StageClass;
         * StageClass.main.scene.layerActions.effectEnd('current_name');
         * @param current_name
         */
        effectEnd: (current_name) => {
            AllTap.$supportEffect({current_name: current_name}).initEnd();
        },

        /**
         * Init in Actions effects.
         * window.StageClass;
         * StageClass.main.scene.layerActions.effectLayerComplete('current_name');
         * @param current_name
         */
        effectLayerComplete: (current_name) => {
            AllTap.$supportEffect({current_name: current_name}).initLayerComplete();
        },

        /**
         * Init in Actions effects.
         * window.StageClass;
         * StageClass.main.scene.layerActions.effectLayerEnd('current_name');
         * @param current_name
         */
        effectLayerEnd: (current_name) => {
            AllTap.$supportEffect({current_name: current_name}).initLayerEnd();
        },

        /**
         * Init in Actions effects.
         * window.StageClass;
         * StageClass.main.scene.layerActions.effectGalleryComplete('current_name');
         * @param current_name
         */
        effectGalleryComplete: (current_name) => {
            AllTap.$supportEffect({current_name: current_name}).initGalleryComplete();
        },

        /**
         * Init in Actions effects.
         * window.StageClass;
         * StageClass.main.scene.layerActions.effectGalleryEnd('current_name');
         * @param current_name
         */
        effectGalleryEnd: (current_name) => {
            AllTap.$supportEffect({current_name: current_name}).initGalleryEnd();
        }
    }
};
